import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

export class BreadCrumbCommonL10n {
  public static home = _('breadcrumb.home');
  public static agent = _('breadcrumb.agent');
  public static headquarter = _('breadcrumb.headquarter');
  public static candidate = _('breadcrumb.candidate');
  public static backoffice = _('breadcrumb.backoffice');
}
